import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';

export const customRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userGroup = authService.getUserGroups();
  const matchForNormalUser = userGroup.filter(grp => grp.includes('DIA-NormalUser-'));
  const matchForCustomsUser = userGroup.filter(grp => grp.includes('DIA-CustomsUser-'));
  const matchForCustomsAdminUser = userGroup.filter(grp => grp.includes('DIA-CustomsAdminUser-'));
  const isSuperAdmin = userGroup.filter(grp => grp.includes('DIA-SuperUser-'))
  if(isSuperAdmin.length > 0 && userGroup.length > 1 && matchForNormalUser.length > 0) {
    return router.navigate(['/RetrievalRequests']);
  }
  if (matchForCustomsUser.length > 0 || matchForCustomsAdminUser.length > 0) {
    return router.navigate(['/AssignedToMe']);
  } else if (isSuperAdmin.length > 0 && userGroup.length == 1) {
    return router.navigate(['/UserManagement']);
  } else {
    return router.navigate(['/Search']);
  }
};